import { useContext } from "react";
import { ContextMenuContext } from "../contexts/ContextMenuContext";

const useContextMenu = () => useContext(ContextMenuContext);

export default useContextMenu;
